import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ApiResponse } from 'app/app.types';
import { resolveMockApiResponse } from './mock-api.registry';

@Injectable()
export class MockApiInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const mockBody = resolveMockApiResponse(req);
        if (!mockBody) {
            return next.handle(req);
        }
        const status = mockBody.status === 'error' ? (mockBody.httpCode ?? 404) : 200;
        const body = this._clientBody(mockBody);
        return of(new HttpResponse({ body, status })).pipe(delay(80));
    }

    /** Return payload for success mocks so ApiResponseInterceptor and callers see the same shape as live API. */
    private _clientBody(mockBody: ApiResponse<unknown>): unknown {
        if (mockBody.status === 'success' || mockBody.status === 'alert') {
            return mockBody.payload;
        }
        return mockBody;
    }
}
